import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  roomStreamToPublishVORaw,
  RoomStreamToPublishVORaw
} from "@youm-front/room/domain";

export class RoomStreamToPublishCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamToPublishCreateResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamToPublishCreateResponseDTORaw) {
    JsonSchemaValidator.assert(
      RoomStreamToPublishCreateResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return roomStreamToPublishVORaw;
  }
}

export type RoomStreamToPublishCreateResponseDTORaw = RoomStreamToPublishVORaw;
